'use client'

import Cookies from 'js-cookie'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export const FBC_COOKIE_NAME = '_fbc'
const FBC_COOKIE_EXPIRES_DAYS = 90

const FbclidCapture = () => {
  const searchParams = useSearchParams()

  useEffect(() => {
    const fbclid = searchParams?.get('fbclid')
    if (!fbclid) {
      return
    }

    const capture = () => {
      if (Cookies.get(FBC_COOKIE_NAME) || !window?.Cookiebot?.consent?.marketing) {
        return
      }

      // Meta's documented fallback format for `fbc`: fb.<subdomain_index>.<ms_timestamp>.<fbclid>
      Cookies.set(FBC_COOKIE_NAME, `fb.1.${Date.now()}.${fbclid}`, { expires: FBC_COOKIE_EXPIRES_DAYS })
    }

    capture()
    window.addEventListener('CookiebotOnConsentReady', capture)
    window.addEventListener('CookiebotOnAccept', capture)
    return () => {
      window.removeEventListener('CookiebotOnConsentReady', capture)
      window.removeEventListener('CookiebotOnAccept', capture)
    }
  }, [searchParams])

  return null
}

export default FbclidCapture
